// Client for the ServiceNow IT-resources endpoint served by backend-node-v2. Base URL =
// EnvironmentConfig.nodeService. Auth = MSAL JWT only — no kid, no x-proxy/x-proxy-token.
import { EnvironmentConfig } from "@me8eon/config";

type TokenFn = () => Promise<string | undefined>;

const BASE = `${EnvironmentConfig.nodeService}/service/itResources`;

export type ListItResourcesResponse = {
    result: {
        queryResult: Record<string, unknown>[];
        message: string;
    };
};

export async function listItResources(isActive: boolean, token: TokenFn): Promise<ListItResourcesResponse> {
    const res = await fetch(`${BASE}?isActive=${isActive}`, {
        headers: { Authorization: `Bearer ${await token()}` },
    });
    if (!res.ok) throw new Error(`itResources/list failed: ${res.status}`);
    return res.json();
}
